import type { Locale } from '../context/LocaleContextProvider'
import { en, TranslationKey } from './en'
import { fr } from './fr'

export type { TranslationKey } from './en'

export type TranslateParams = Record<string, string | number>
export type Translate = (key: TranslationKey, params?: TranslateParams) => string

const TRANSLATIONS: Record<Locale, Record<TranslationKey, string>> = {
  'en-CA': en,
  'fr-CA': fr,
}

/**
 * @description returns `t(key, params)` for a locale: the string for `key`, with each `{{name}}` replaced by
 * `params.name`. Components get it from `useLocale().t`.
 * @example createTranslate('fr-CA')('blog.minRead', { readTime: 5 }) => '5 min de lecture'
 */
export const createTranslate =
  (locale: Locale): Translate =>
  (key, params) =>
    TRANSLATIONS[locale][key].replace(/{{(\w+)}}/g, (match, name: string) =>
      params && params[name] !== undefined ? String(params[name]) : match,
    )
